<template>
  <div v-if="product.properties.reviews" class="flex items-center text-sm">
    <span class="mr-2">{{ formattedRating }}</span>
    <notation :notation="product.properties.reviews.avg" :max="5" />
    <a href="#" class="ml-2 hover:underline" @click.stop.prevent="scrollTo('#reviews')">({{ product.properties.reviews.total }} avis)</a>
  </div>
</template>

<script>
import Notation from '../Notation'
export default {
  components: {
    Notation
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  computed: {
    formattedRating () {
      const avg = this.product?.properties?.reviews?.avg || 0
      if (avg === 5) {
        return '5'
      }
      return avg.toFixed(1)
    }
  },
  methods: {
    scrollTo (id) {
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>
